import { SxProps } from "@mui/material";

export const sxPagination: SxProps = {
    width: 'auto',
    height: '32px',
    background: 'unset',
    color: 'unset',
    fontSize: 'unset',
    fontStyle: 'unset',
    fontWeight: 'unset',
    lineHeight: 'unset',
    position: 'unset',
    button: {
        fontFamily: 'UnimedSans-Bold',
        backgroundColor: '#EEE',
        color: '#5F5F5F'
    }
}

export const sxSubtitle: SxProps = {
    color: '#4C4C4C',
    fontFamily: 'Unimed-Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '24px',
    maxWidth: '580px'
}

export const sxTypographySubTitleBold: SxProps = {
    color: '#383838',
    size: '24px',
    fontFamily: 'UnimedSans-Bold',
    marginBottom: '24px'
};

export const sxTypographySubTitle: SxProps = {
    color: '#383838',
    size: '16px',
    fontFamily: 'Unimed-Sans',
    marginBottom: '24px'
};

export const sxTable: SxProps = {
    borderRadius: '10px',
    maxWidth: '636px',
    width: '100%',
    '@media (max-width: 500px)': {
        width: '85vw'
    },
}

export const sxModal: SxProps = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '578px',
    width: '85%',
    bgcolor: '#fff',
    borderRadius: '16px',
    border: 'none',
    boxShadow: '0px 4px 100px 0px rgba(56, 56, 56, 0.20)',
    padding: '32px',
    gap: '24px',
}